//Investor
export const RESET_INVESTOR = 'RESET_INVESTOR';
export const SET_USER_INFORMATION = 'SET_USER_INFORMATION';

//Adviser
export const ADVISER_INVITE_INVESTOR = 'ADVISER_INVITE_INVESTOR';
export const RESET_ADVISER_INVITE_INVESTOR = 'RESET_ADVISER_INVITE_INVESTOR';
